import gql from 'graphql-tag';
import { client } from './client';

export const fetchUserProjects = async (param) => {
  const results = await client.query({
    query: gql`query(
      $page: Int,
      $pageSize: Int,
      $orgId: Int,
      $isArchived: Boolean,
      $leadId: Int,
      $key: String,
      $sortKey: String
    ) {
      loginWeddings(
        page: $page,
        pageSize: $pageSize,
        orgId: $orgId,
        isArchived: $isArchived,
        leadId: $leadId,
        key: $key,
        sort: $sortKey
      ) {
        start
        limit
        total
        pages
        currentPage
        items {
          weddingId
          isEnabled
          weddingName
          weddingShortname
          weddingLeadName
          weddingDate
          weddingAddress
          serviceType
          image100
          image306
          isOwner
          isSample
          orgId
          archivedAt
          archivedByFirstname
          archivedByLastname
          creationStatus
        }
      }
    }`,
    variables: param,
    fetchPolicy: 'network-only',
  });
  return results.data;
};

export const fetchProjectsLeads = async () => {
  const results = await client.query({
    query: gql`
      query {
        weddingsLeads {
          loginId
          firstname
          lastname
        }
      }
    `,
  });
  return results.data;
};

export const NOTIFICATION_PROJECT_FIELDS = gql`
  fragment NotificationProjectFields on Project {
    id
    name
    weddingDate
  }
`;

export const archiveWedding = async ({ id, action }) => {
  const param = {
    input: {
      weddingId: parseInt(id, 10),
      action,
    },
  };
  const results = await client.mutate({
    mutation: gql`
      mutation archiveWedding($input: ArchiveWeddingInput!) {
        archiveWedding(input: $input) {
          wedding {
            id
            isArchived
            isDeleted
            name
          }
        }
      }
    `,
    variables: param,
    errorPolicy: 'all',
  });
  return results.data;
};

export const deleteWedding = async ({ id }) => {
  const param = {
    input: {
      weddingId: parseInt(id, 10),
    },
  };
  const results = await client.mutate({
    mutation: gql`
      mutation deleteWedding($input: DeleteWeddingInput!) {
        deleteWedding(input: $input) {
          wedding {
            id
            isArchived
            isDeleted
            name
          }
        }
      }
    `,
    variables: param,
    errorPolicy: 'all',
  });
  return results.data;
};

export const createProject = async ({ weddingBody }) => {
  const param = {
    input: {
      body: weddingBody,
    },
  };

  const results = await client.mutate({
    mutation: gql`
      mutation createWedding($input: CreateWeddingInput!) {
        createWedding(input: $input) {
          wedding {
            id
          }
        }
      }
    `,
    variables: param,
  });

  return results.data;
};

export const updateProject = async ({ id, weddingBody }) => {
  const param = {
    input: {
      weddingId: parseInt(id, 10),
      body: weddingBody,
    },
  };

  const results = await client.mutate({
    mutation: gql`
      mutation updateWedding($input: UpdateWeddingInput!) {
        updateWedding(input: $input) {
        wedding {
          weddingId
          isEnabled
          weddingName
          weddingShortname
          weddingLeadName
          weddingDate
          weddingAddress
          serviceType
          image100
          image306
        }
      }
    }`,
    variables: param,
  });
  return results.data;
};

export const updateChecklistDates = async ({ id, weddingBody }) => {
  const param = {
    input: {
      weddingId: parseInt(id, 10),
      body: weddingBody,
    },
  };

  const results = await client.mutate({
    mutation: gql`
      mutation updateChecklistDates($input: UpdateChecklistDatesInput!) {
        updateChecklistDates(input: $input) {
          success
        }
      }
    `,
    variables: param,
  });

  return results.data;
};

export const createSampleProject = async () => {
  const results = await client.mutate({
    mutation: gql`
      mutation createSampleWedding {
        createSampleWedding {
          success
        }
      }
    `,
  });

  return results.data;
};

export const fetchOrgSampleWeddingStatus = async () => {
  const results = await client.query({
    query: gql`
      query {
        me {
          organization {
            sampleWeddingStatus
          }
        }
      }
    `,
    fetchPolicy: 'network-only',
    errorPolicy: 'all',
  });
  return results.data;
};

export const fetchOrgSampleWedding = async () => {
  const results = await client.query({
    query: gql`
      query {
        organizationSampleWedding {
          id
          name
        }
      }
    `,
    errorPolicy: 'all',
  });
  return results.data;
};

export const fetchWeddingData = async ({ id }) => {
  const param = {
    weddingId: parseInt(id, 10),
  };
  const results = await client.query({
    query: gql`
      query ($weddingId: Int) {
        wedding(weddingId: $weddingId) {
          id
          organizationId
          lead
          projectType
          name
          party
          profileImage {
            key
          }
          profileImageUrls
          originalProfileImage {
            key
          }
          weddingDate
          estimatedGuestCount
          address
          location {
            id
            data
            city
            state
            formattedAddress
            country
          }
          venueName
          serviceTypeId
          timezone
          features
          currency
          datePreference
          timePreference
          allDay
          startTime
          endTime
        }
      }
    `,
    variables: param,
    errorPolicy: 'all',
    fetchPolicy: 'network-only',
  });
  return results.data;
};

export const fetchOrgWeddingTemplates = async () => {
  const results = await client.query({
    query: gql`
      query {
        organizationWeddingTemplates {
          value: id
          label: name
          templateType
        }
      }
    `,
    errorPolicy: 'all',
  });
  return results.data;
};

export const saveWeddingsPreferences = async (options) => {
  const param = {
    input: {
      sort: options.sort,
      sortArchive: options.sortArchive,
      view: options.view,
      location: options.location,
      projectLead: options.projectLead,
      service: options.service,
      leadId: options.leadId,
    },
  };
  const results = await client.mutate({
    mutation: gql`
      mutation saveWeddingsPreferences($input: SaveWeddingsPreferencesInput!) {
        saveWeddingsPreferences(input: $input) {
          preferences
        }
      }
    `,
    variables: param,
    errorPolicy: 'all',
  });

  return results.data;
};

export const updateProjectsDownloadPreferences = async (options) => {
  const param = {
    input: JSON.stringify(options),
  };

  const results = await client.mutate({
    mutation: gql`
      mutation updateWeddingsDownloadPreferences($input: JSONString!) {
        updateWeddingsDownloadPreferences(input: $input) {
          preferences
        }
      }
    `,
    variables: param,
    errorPolicy: 'all',
  });
  return results.data;
};

export const fetchWeddingsNotification = async (weddingId) => {
  const param = {
    weddingId: parseInt(weddingId, 10),
  };
  const results = await client.query({
    query: gql`
      query ($weddingId: Int) {
        weddingsNotification(weddingId: $weddingId) {
          prefs
        }
      }
    `,
    variables: param,
    errorPolicy: 'all',
    fetchPolicy: 'network-only',
  });

  return results.data;
};

export const saveWeddingsNotification = async (notification, id) => {
  const param = {
    input: {
      preferences: notification,
      weddingId: parseInt(id, 10),
    },
  };

  const results = await client.mutate({
    mutation: gql`
      mutation saveWeddingsNotification(
        $input: SaveWeddingsNotificationInput!
      ) {
        saveWeddingsNotification(input: $input) {
          preferences
        }
      }
    `,
    variables: param,
  });
  return results.data;
};

export const fetchWeddingsReminder = async (id, key) => {
  const param = {
    weddingId: parseInt(id, 10),
    setKey: key,
  };
  const results = await client.query({
    query: gql`
      query ($weddingId: Int, $setKey: String) {
        weddingsReminder(weddingId: $weddingId, setKey: $setKey) {
          id
          setId
          spec
        }
      }
    `,
    variables: param,
    errorPolicy: 'all',
    fetchPolicy: 'network-only',
  });

  return results.data;
};

export const deleteWeddingsReminder = async (id) => {

  const param = {
    input: {
      id: parseInt(id, 10),
    },
  };

  const results = await client.mutate({
    mutation: gql`
      mutation DeleteWeddingsReminder($input:DeleteWeddingsReminderInput!){
        deleteWeddingsReminder(input:$input){
          isDeleted
        }
      }
    `,
    variables: param,
  });
  return results.data;
};

export const updateWeddingsReminder = async (weddingsId, reminderBody) => {
  const param = {
    input: {
      weddingsId: parseInt(weddingsId, 10),
      key: reminderBody.reminderType,
      value: reminderBody.value,
      count: reminderBody.count ? parseInt(reminderBody.count, 10) : 0,
      setId: reminderBody.setId ? parseInt(reminderBody.setId, 10) : 0,
    },
  };
  const results = await client.mutate({
    mutation: gql`
      mutation updateWeddingsReminder($input:UpdateWeddingsReminderInput!){
        updateWeddingsReminder(input:$input){
          reminder{
            id
            setId
            spec
          }
        }
      }
    `,
    variables: param,
  });
  return results.data;
};

export const updateDeltaWeddingsReminder = async (id, count) => {
  const param = {
    input: {
      id: parseInt(id, 10),
      count: parseInt(count, 10),
    },
  };

  const results = await client.mutate({
    mutation: gql`
        mutation updateDeltaWeddingsReminder($input:UpdateDeltaWeddingsReminderInput!){
          updateDeltaWeddingsReminder(input:$input){
            reminder{
              id
              setId
              spec
            }
          }
        }
      `,
    variables: param,
  });
  return results.data;
};

export const saveDefaultWeddingReminders = async (id, key, reminders) => {
  const param = {
    input: {
      id: parseInt(id, 10),
      key,
      reminders: JSON.stringify(reminders),
    },
  };

  const results = await client.mutate({
    mutation: gql`
      mutation saveDefaultWeddingReminders(
        $input: SaveDefaultWeddingRemindersInput!
      ) {
        saveDefaultWeddingReminders(input: $input) {
          success
        }
      }
    `,
    variables: param,
  });
  return results.data;
};

export const weddingsLimit = async () => {
  const results = await client.query({
    query: gql`
      query{weddingsLimit {
        limit
        isExceeded
        isOwner
        activeWeddingCount
      }}
    `,
    errorPolicy: 'all',
    fetchPolicy: 'network-only',
  });
  return results.data;
};


export const updateProjectFeatures = async ({ id, key, value }) => {
  const param = {
    input: {
      id: parseInt(id, 10),
      key,
      value,
    },
  };
  const results = await client.mutate({
    mutation: gql`
     mutation updateProjectFeatures($input: UpdateProjectFeaturesInput!) {
        updateProjectFeatures(input: $input) {
          checklistReleased,
          notesReleased,
        }
      }
    `,
    variables: param,
    errorPolicy: 'all',
  });
  return results.data;
};

export const fetchProjectFeatures = async ({ id }) => {
  const param = {
    id: parseInt(id, 10),
  };
  const results = await client.query({
    query: gql`query($id: Int){
      projectFeatures(id: $id) {
        checklistReleased,
        notesReleased,
        designStudioReleased,
      }
    }
    `,
    variables: param,
    errorPolicy: 'all',
    fetchPolicy: 'network-only',
  });
  return results.data;
};

export const weddingPermissions = async ({ weddingId }) => {
  const param = {
    weddingId: parseInt(weddingId, 10),
  };
  const results = await client.query({
    query: gql`query weddingPermissions($weddingId: Int) {
      weddingsPermissions(weddingId: $weddingId) {
        name
        value
      }
    }
    `,
    variables: param,
    errorPolicy: 'all',
    fetchPolicy: 'network-only',
  });
  return results.data;
};
